import React from 'react';

import { useProfileState, useProfileActions } from './ProfileContext';
import { deleteUserExperience } from './restApi';

import Form from '../../Shared/UI/Form/components/Form';
import FormInstruction from '../../Shared/UI/FormInstruction/components/FormInstruction';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

const DeleteUserExperienceForm = () => {
  const profileState = useProfileState();
  const { onResponse, onError, closeDeleteUserExperienceModal } = useProfileActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const handleSubmit = () => {
    deleteUserExperience({
      onResponse,
      onError,
      body: {
        authenticityToken,
        deleteUserExperienceForm: profileState?.deleteUserExperienceForm,
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <FormInstruction>
        Are you sure you want to delete this experience?
      </FormInstruction>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button
            variant="secondary"
            onClick={() => {
              if (profileState?.user?.isAuthenticatedUser) {
                closeDeleteUserExperienceModal();
              }
            }}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="destructive"
          >
            Yes. Delete This Experience.
          </Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default DeleteUserExperienceForm;
